import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

export const WhyNeroChar = () => {
  const { t } = useLang();
  const w = t.whyNero;

  return (
    <section className="bg-background border-b border-border" data-testid="why-nerochar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline index="07">{w.label}</Overline>
              <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-nero-ink leading-[1.05]">
                {w.title}
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="border-t border-border">
              {w.points.map((p, i) => (
                <Reveal key={i} delay={(i % 4) * 0.05}>
                  <div
                    className="group flex items-center gap-5 border-b border-border py-5"
                    data-testid={`why-nero-point-${i}`}
                  >
                    <span className="font-heading text-xs font-bold text-nero-green w-6 tabular-nums">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-heading text-lg sm:text-xl font-medium tracking-tight text-nero-ink">
                      {p}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
